// Injury cost data based on NCCI 2021-2022 workers' compensation data
const injuryData = {
    44179: { name: "All Injuries Average", cost: 44179, multiplier: 1.2 },
    51047: { name: "Falls or Slips", cost: 51047, multiplier: 1.1 },
    63119: { name: "Burns", cost: 63119, multiplier: 1.1 },
    46902: { name: "Caught Between Objects", cost: 46902, multiplier: 1.2 },
    90914: { name: "Motor Vehicle (on-site)", cost: 90914, multiplier: 1.1 },
    35000: { name: "Cuts/Lacerations", cost: 35000, multiplier: 1.5 },
    42000: { name: "Back Injuries", cost: 42000, multiplier: 1.3 },
    38000: { name: "Struck by Object", cost: 38000, multiplier: 1.4 },
    55000: { name: "Electrocution", cost: 55000, multiplier: 1.1 }
};

function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(amount);
}

function formatNumber(num) {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }).format(num);
}

function calculateIncidentCosts() {
    // Get input values
    const injuryType = document.getElementById('injuryType').value;
    const employees = parseInt(document.getElementById('employees').value) || 500;
    const projectDuration = parseInt(document.getElementById('projectDuration').value) || 18;
    const profitMargin = 8; // Fixed at 8%
    const coordinationLevel = parseFloat(document.getElementById('coordinationLevel').value) || 1.0;

    // Calculate realistic incident count based on BLS construction data
    // BLS: 1.5 recordable incidents per 100 workers annually
    const monthlyIncidentRate = 1.5 / 12; // 0.125 per 100 workers per month
    const baseIncidentCount = (monthlyIncidentRate * projectDuration * employees) / 100;

    // Get injury data
    const injury = injuryData[injuryType];
    const directCostPerIncident = injury.cost;
    const indirectMultiplier = injury.multiplier;

    // Calculate costs
    const indirectCostPerIncident = directCostPerIncident * indirectMultiplier;
    const totalCostPerIncident = directCostPerIncident + indirectCostPerIncident;

    // Adjust incident count based on coordination level
    const adjustedIncidents = baseIncidentCount * coordinationLevel;

    // Calculate total project costs
    const totalDirectCosts = directCostPerIncident * adjustedIncidents;
    const totalIndirectCosts = indirectCostPerIncident * adjustedIncidents;
    const totalProjectCosts = totalDirectCosts + totalIndirectCosts;

    // Calculate additional metrics
    const salesRequired = totalProjectCosts * (100 / profitMargin);
    const costPerWorker = totalProjectCosts / employees;
    
    // Calculate prevention savings (difference between basic vs excellent coordination)
    const basicIncidents = baseIncidentCount * 1.0;
    const excellentIncidents = baseIncidentCount * 0.4;
    const preventionSavings = (basicIncidents - excellentIncidents) * totalCostPerIncident;

    // Update display
    document.getElementById('totalCost').textContent = formatCurrency(totalProjectCosts);
    document.getElementById('incidentDisplay').textContent = formatNumber(adjustedIncidents);
    document.getElementById('directCostTotal').textContent = formatCurrency(totalDirectCosts);
    document.getElementById('indirectCostTotal').textContent = formatCurrency(totalIndirectCosts);
    document.getElementById('multiplierUsed').textContent = indirectMultiplier + 'x';
    
    document.getElementById('directPerIncident').textContent = formatCurrency(directCostPerIncident);
    document.getElementById('indirectPerIncident').textContent = formatCurrency(indirectCostPerIncident);
    document.getElementById('totalPerIncident').textContent = formatCurrency(totalCostPerIncident);
    document.getElementById('adjustedIncidents').textContent = formatNumber(adjustedIncidents);
    document.getElementById('finalTotal').textContent = formatCurrency(totalProjectCosts);
    
    document.getElementById('salesRequired').textContent = formatCurrency(salesRequired);
    document.getElementById('costPerWorker').textContent = formatCurrency(costPerWorker);
    document.getElementById('preventionSavings').textContent = formatCurrency(preventionSavings);
}

// Add event listeners to all inputs
document.addEventListener('DOMContentLoaded', function() {
    const inputs = document.querySelectorAll('input, select');
    inputs.forEach(input => {
        input.addEventListener('input', calculateIncidentCosts);
        input.addEventListener('change', calculateIncidentCosts);
    });
    
    // Initial calculation
    calculateIncidentCosts();
});

function resetCalculator() {
    // Reset all inputs to their default values
    document.getElementById('injuryType').value = '44179';
    document.getElementById('employees').value = '500';
    document.getElementById('projectDuration').value = '18';
    document.getElementById('coordinationLevel').value = '1.0';
    
    // Recalculate with default values
    calculateIncidentCosts();
}

// Add event listener for the reset button
document.addEventListener('DOMContentLoaded', function() {
    const inputs = document.querySelectorAll('#safety input, #safety select');
    inputs.forEach(input => {
        input.addEventListener('input', calculateIncidentCosts);
        input.addEventListener('change', calculateIncidentCosts);
    });
    
    // Reset button event listener
    const resetButton = document.getElementById('reset-safety');
    if (resetButton) {
        resetButton.addEventListener('click', resetCalculator);
    }
    
    // Initial calculation
    calculateIncidentCosts();
});